// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import Focusable from 'components/focus/Focusable';

const FocusTrap = ({ children, className, allowBrowserHandling }) => {
  const onAction = () => {
    return allowBrowserHandling ? 'stopPropagation' : true;
  };

  return (
    <Focusable
      onAction={onAction}
      render={() => children}
      className={className}
    />
  );
};

FocusTrap.propTypes = {
  allowBrowserHandling: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

FocusTrap.defaultProps = {
  allowBrowserHandling: false,
  children: null,
  className: null,
};

export default FocusTrap;
